import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./useAuth";
import { consumeAuthReturnTo } from "./auth-return-url";

const AuthCallbackPage = () => {
  const { isAuthenticated, isLoading, error } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading) {
      if (isAuthenticated) {
        void navigate(consumeAuthReturnTo() ?? "/", { replace: true });
      } else if (error) {
        void navigate(`/?auth_error=${encodeURIComponent(error)}`, { replace: true });
      }
    }
  }, [isAuthenticated, isLoading, error, navigate]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        gap: "16px",
      }}
    >
      {error ? (
        <p style={{ color: "red" }}>Authentication failed: {error}</p>
      ) : (
        <>
          <div
            style={{
              width: "40px",
              height: "40px",
              border: "3px solid #f3f3f3",
              borderTop: "3px solid #C0AFF2",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
            }}
          />
          <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
          <p style={{ color: "#666" }}>Signing you in…</p>
        </>
      )}
    </div>
  );
};

export default AuthCallbackPage;
